import styled from "styled-components";
import CollapseComponent from "antd/es/collapse";

export const Collapse = styled(CollapseComponent)`
  margin: "10px 0px 10px";
`;
